/**
 * Team member status DTO - represents the wire format used by the backend API.
 * This is the single source of truth for team member status values in API requests/responses.
 */
export enum TeamMemberStatusDTO {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  BASIC = 'BASIC',
  ARCHIVED = 'ARCHIVED',
  PLACEHOLDER = 'PLACEHOLDER',
  /** Display-only: a synced user that may duplicate another one. Only super admins receive it. */
  NEEDS_REVIEW = 'NEEDS_REVIEW',
}

/**
 * Type alias for team member status in API requests.
 * Makes intent clear without code duplication.
 */
export type TeamMemberStatusRequest = TeamMemberStatusDTO;

/**
 * Type alias for team member status in API responses.
 * Makes intent clear without code duplication.
 */
export type TeamMemberStatusResponse = TeamMemberStatusDTO;
